import React, {useState} from "react";


const ContactCard = (props) => {

  const [openSteps, setOpenSteps] = useState(false);

  return(
    <div className={`need-know-item ${openSteps && "content-shown"}`} id={`#${props.key}`} key={props.key}>
    <h3 
          onClick={(newOpen) => {
              (openSteps) ?
                  setOpenSteps(!newOpen)
              :
                  setOpenSteps(newOpen)
          }}
          className="item-action-container"
      >
          <div className={`item-title ${openSteps && "selected"}`}>
              {props.title}
          </div>
          {(openSteps) ? 
              <img 
                  src="https://cdn.vostro.app/cdn/hotspots/base/icon arrow up.svg" 
                  alt="minus-icon" 
                  className="minimize-expand-icon"
              /> 
              :
              <img 
                  src="https://cdn.vostro.app/cdn/hotspots/base/Icon awesome-plus.svg" 
                  alt="plus-icon" 
                  className="plus-expand-icon"
              />
          }
      </h3>
      <div className={`content ${openSteps && "show"}`}>
        <div className="contact-card-inner">
          <ul className="contact-card-list">
            {
              props.platforms.map(platform => {
                return (
                  <li key={platform.id}>
                    <a onClick={platform.openContact} className="contact-link">
                      {platform.icon} 
                      <span className="contact-label">{platform.label}</span>
                    </a>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
  </div>
  )
};

export default ContactCard;